import { useEffect } from "react";
import { Card, CardContent } from "../../../../components/ui/card";
import { LoadingCardSkeleton } from "../../../../components/ui/skeleton-loaders";
import { useToast } from "../../../../hooks/use-toast";
import { CompaniesTable } from "./components/companies-table";
import { EditCredentialsDialog } from "./components/edit-credentials-dialog";
import { RegistrationForm } from "./components/registration-form";
import { useCompanyRegistration } from "./hooks/use-company-registration";

export default function CompanyRegistration() {
  const { toast } = useToast();
  const {
    registrationForm,
    editForm,
    companies,
    isLoading,
    isRegistering,
    isUpdating,
    editingCompany,
    xamaDbName,
    handleRegister,
    handleEditClick,
    handleUpdate,
    handleCancelEdit,
    registerSuccess,
    updateSuccess,
    registerError,
    updateError,
  } = useCompanyRegistration();

  useEffect(() => {
    if (registerSuccess) {
      toast({
        title: "Sucesso",
        description: "Empresa cadastrada com sucesso!",
      });
    }
  }, [registerSuccess, toast]);

  useEffect(() => {
    if (updateSuccess) {
      toast({
        title: "Sucesso",
        description: "Credenciais atualizadas com sucesso!",
      });
    }
  }, [updateSuccess, toast]);

  useEffect(() => {
    if (registerError) {
      toast({
        title: "Erro ao cadastrar",
        description: "Ocorreu um erro ao cadastrar a empresa. Tente novamente.",
        variant: "destructive",
      });
    }
  }, [registerError, toast]);

  useEffect(() => {
    if (updateError) {
      toast({
        title: "Erro ao atualizar",
        description: "Ocorreu um erro ao atualizar as credenciais. Tente novamente.",
        variant: "destructive",
      });
    }
  }, [updateError, toast]);

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground">
          Cadastro de Empresas
        </h1>
        <p className="text-muted-foreground mt-1">
          Cadastrar e gerenciar empresas do sistema
        </p>
      </div>

      <div className="space-y-6">
        <RegistrationForm
          form={registrationForm}
          onSubmit={handleRegister}
          isSubmitting={isRegistering}
          xamaDbName={xamaDbName}
        />

        {isLoading ? (
          <LoadingCardSkeleton />
        ) : (
          <CompaniesTable companies={companies} onEditClick={handleEditClick} />
        )}

        <EditCredentialsDialog
          open={!!editingCompany}
          company={editingCompany}
          form={editForm}
          onSave={handleUpdate}
          onCancel={handleCancelEdit}
          isSaving={isUpdating}
        />
      </div>
    </div>
  );
}
